<template>
    <div class="phone-box">
        <div class="message">
            <div class="message-item" v-for="(item,key) of form" :key="key">
                <template v-if="item.type == 'select'">
                    <div class="message-title" :class="item.require?'message-title__reuqire':''">{{item.title}}</div>
                    <select v-model="item.value" class="message-input" :class="!item.value?'gray':''" @change="selectChange($event,key)">
                        <option value="" v-if="key!='isCn'">{{'请选择'+item.title}}</option>
                        <option v-for="list in item.selectList" :key="list.uuid" :value="list.uuid">{{list.name}}</option>
                    </select>
                </template>
                <template v-else-if="item.type == 'radio'">
                    <div class="message-title" :class="item.require?'message-title__reuqire':''">{{item.title}}</div>
                    <div class="message-input message-input__radio">
                        <div class="message-input__item" v-for="list in item.selectList" :key="list.uuid" :value="list.uuid" @click="radioChange(list.uuid,key)">
                            <img src="@/assets/selected.png" v-if="list.uuid == item.value" class="message-input__image">
                            <img src="@/assets/select.png" v-else class="message-input__image">
                            <div class="message-input__label">{{list.name}}</div>
                        </div>
                    </div>
                </template>
                <template v-else-if="item.type == 'date'">
                    <div class="message-title" :class="item.require?'message-title__reuqire':''">{{item.title}}</div>
                    <input type="date" v-model="item.value" :placeholder="'请选择'+item.title" class="message-input"/>
                </template>
                <template v-else-if="item.type == 'image'">
                    <div class="message-title" :class="item.require?'message-title__reuqire':''">{{item.title}}</div>
                    <div class="upload-input-box" v-if="item.value">
                        <img :src="imageUrl+item.value" class="message-image"/>
                        <input class="upload-input" type="file" accept="image/*" @change="getImage($event,item.key)"/>
                    </div>
                    <div class="upload-input-box" v-else>
                        <div class="upload-btn">
                            <img src="@/assets/jiahao.png" class="upload-btn__image">
                            <div class="upload-btn__text">点击上传</div>
                        </div>
                        <input class="upload-input" type="file" accept="image/*" @change="getImage($event,item.key)"/>
                    </div>
                </template>
                <template v-else-if="!item.hidden">
                    <div class="message-title" :class="item.require?'message-title__reuqire':''">{{item.title}}</div>
                    <input type="text" :readonly="item.readonly" :placeholder="'请填写'+item.title" v-model="item.value" class="message-input">
                </template>
            </div>
        </div>
        <div class="agreement">
            <div class="agreement-select" @click="agreementSelect=!agreementSelect" :class="agreementSelect?'agreement-selected':''"></div>
            <span>请阅读<span class="agreement-text" @click="readAgrement">《用户协议》</span></span>
        </div>
        <div class="btn-box">
            <!-- <div class="btn" @click="back">返回</div> -->
            <div class="btn btn-inner" @click="confirm">提交</div>
        </div>
        <transition name="detailEnter">
            <div class="agreement-box" v-if="agreement">
                <div class="agreement-page">
                    <span class="agreement-title">
                        用户协议
                        <img src="@/assets/close.png" alt="" class="close-image" @click="agreement = false">
                    </span>
                    <div class="agreement-content">
                        <div class="agreement-detail__title">
                            用户服务隐私协议
                        </div>
                        <div class="agreement-detail__introduction">
                            引言
                        </div>
                        <div class="agreement-detail">欢迎您使用太仓市犬只管理平台小程序！太仓市犬只管理平台小程序（以下简称"太仓市犬只管理平台小程序"）根据《用户服务协议》（以下简称"本协议"）为您提供服务。</div>
                        <div class="agreement-detail">为使用太仓市犬只管理平台小程序服务，请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款、对用户权利进行限制的条款等。限制、免责条款或者其他涉及您重大权益的条款可能以加粗形式提示您重点注意。</div>
                        <div class="agreement-detail">除非您已充分阅读、完全理解并接受本协议所有条款，否则您无权注册、登录或使用太仓市犬只管理平台小程序服务。您点击"登录（具体措辞详见注册页面）"或您进行注册、使用、获取用户账号、登录及使用相关服务的行为或者以其他任何明示或者默示方式表示接受本协议的，均视为您已阅读并同意签署本协议。</div>
                        <div class="agreement-detail">如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称"监护人"）的陪同下阅读和签署本协议</div>
                        <div class="agreement-detail">您有违反本协议的任何行为时，太仓市犬只管理平台小程序有权根据您违反约定的情形单方采取限制、中止或终止向您提供服务等措施，并有权追究您相关责任。</div>
                        <div class="agreement-detail__subtitle">一、定义与解释</div>
                        <div class="agreement-detail">如无特别说明，下列术语在本协议中的定义为：</div>
                        <div class="agreement-detail">1.1用户是指注册、登录、使用太仓市犬只管理平台小程序的个人或组织，在本协议中更多地称为"您"。</div>
                        <div class="agreement-detail">1.2太仓市犬只管理平台小程序是用户通过"实人＋实名"身份认证核验，即可在小程序办理使用犬只微信小程序。（以下简称"太仓市犬只管理平台小程序")</div>
                        <div class="agreement-detail">1.3人脸识别验证身份功能是指由公安部第一研究所承建的"互联网＋"可信身份证认证平台，公安部全国公民身份信息查询中心提供的身份核验数据</div>
                        <div class="agreement-detail">1.4太仓市犬只管理平台小程序账号是指您在太仓市犬只管理平台小程序通过人脸识别或微信支付等方式注册的，用于登录太仓市犬只管理平台小程序办理事项的账号。（以下简称"太仓市犬只管理平台小程序账号")</div>
                        <div class="agreement-detail__subtitle">二、协议适用范围</div>
                        <div class="agreement-detail">2.1本协议是太仓市犬只管理平台小程序制定的关于获取和使用太仓市犬只管理平台小程序账号的相关规则。本规则适用于由太仓市犬只管理平台小程序提供的需要注册或使用太仓市犬只管理平台小程序账号的全部软件或服务。</div>
                        <div class="agreement-detail">2.2本协议项下的登录服务包括两种情况：太仓市犬只管理平台小程序向用户提供的通过人脸识别注册账号登录使用第三方应用（包括第三方网站、系统或导出的数据等）的服务；太仓市犬只管理平台小程序向用户提供的通过微信支付密码账号登录使用第三方应用（包括第三方网站、系统或导出的数据等）的服务（以下简称本服务）。
（本协议中的"第三方"若无特别说明，均为为用户提供相应网站、应用或其他服务的政府部门、公用企事业单位或其他公共服务组织，太仓市犬只管理平台小程序将在具体应用页面底部提示提供方。)
</div>
                        <div class="agreement-detail">2.3您通过太仓市犬只管理平台小程序提供的账号使用相关的软件和服务时，须同时遵守各项服务的单独协议。</div>
                        <div class="agreement-detail__subtitle">三、账号注册及管理</div>
                        <div class="agreement-detail__subtitle">3.1账号注册</div>
                        <div class="agreement-detail">3.1.1用户可选择人脸识别验证身份方式或微信支付方式注册登录太仓市犬只管理平台小程序账号。新用户在通过人脸识别验证身份功能、微信支付方式登录时系统将为您自动匹配一个账号，账号密码由您自行设置并由您负责保管。</div>
                        <div class="agreement-detail">3.1.2您在注册及使用太仓市犬只管理平台小程序服务时，必须向太仓市犬只管理平台小程序提供真实、准确、完整、合法有效的资料，且有义务维持并及时更新您的资料。根据实名认证方式的不同个人所需提供的实名认证资料包括但不限干用户服务隐私协议姓名、身份证信息等。若太仓市犬只管理平台小程序有合理理由怀疑您提供的身份信息及相关资料错误、不实、过时或不完整的，太仓市犬只管理平台小程序有权限制或停止向您提供部分或全部服务，您同时须承担因此引起的相应责任及后果。</div>
                        <div class="agreement-detail">3.1.3您不得冒用他人名义申请非本人的用户账号。如有违反，经核实后，太仓市犬只管理平台小程序或第三方服务平台有权删除其账号。对于冒用他人名义申请非本人的用户账号而引起的一切责任，由冒用者承担。</div>
                        <div class="agreement-detail">3.1.4若您为个人用户，您确认并授权，太仓市犬只管理平台小程序有权要求核对您的有效身份信息，并留存有效必要文件，您应积极配合，否则太仓市犬只管理平台小程序有权限制或停止向您提供部分或全部服务。</div>
                        <div class="agreement-detail__subtitle">3.2账号管理</div>
                        <div class="agreement-detail">3.2.1太仓市犬只管理平台小程序账号的所有权归太仓市犬只管理平台小程序所有，用户完成申请注册手续后，仅获得账号的使用权，且该使用权仅属于初始申请注册人。</div>
                        <div class="agreement-detail">3.2.2您有责任妥善保管注册账号信息及账号密码的安全，您需要对您注册账号以及密码下的行为承担法律责任。当在您知悉您的账号已经失密或者可能已经失密时，您应立即通知太仓市犬只管理平台小程序。</div>
                        <div class="agreement-detail">3.2.3您确认只有您本人可以使用您的账号。在您决定不再使用该账号时，您应向太仓市犬只管理平台小程序申请注销该账号。您应对因您未能遵守本款约定而发生的任何损失、损毁及其他不利后果负责。</div>
                        <div class="agreement-detail">3.2.4如果您当前使用的账号并不是您初始申请注册的或者不是通过太仓市犬只管理平台小程序提供的其他途径获得的，您不得用该号码登录或进行任何操作，并请您在第一时间通知太仓市犬只管理平台小程序。</div>
                        <div class="agreement-detail">3.2.5如您违反相关法律法规、本规则或其他相关协议、规则，太仓市犬只管理平台小程序有权限制、中止、冻结或终止您对账号的使用，且根据实际情况决定是否恢复您对账号的使用，而由此产生的损失由您自行承担。</div>
                        <div class="agreement-detail__subtitle">四、用户个人信息保护</div>
                        <div class="agreement-detail">4.1太仓市犬只管理平台小程序非常重视对用户个人信息的保护。太仓市犬只管理平台小程序将按照本协议及《太仓市犬只管理平台小程序隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息保护规定的内容与上述《太仓市犬只管理平台小程序隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《太仓市犬只管理平台小程序隐私政策》的内容为准。</div>
                        <div class="agreement-detail">4.2如您认为您的个人信息被太仓市犬只管理平台小程序超目的使用、或被其他用户侵权，请立即与太仓市犬只管理平台小程序联系，并按照要求提供相应的证明资料，太仓市犬只管理平台小程序将及时调查核实处理。</div>
                        <div class="agreement-detail">4.3一般情况下，你可随时浏览、修改自己提交的信息，但出于安全性和身份识别的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。</div>
                        <div class="agreement-detail">4.4太仓市犬只管理平台小程序将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</div>
                        <div class="agreement-detail__subtitle">五、用户行为规范</div>
                        <div class="agreement-detail">5.1您不得因非正常使用服务之目的恶意注册、获取太仓市犬只管理平台小程序账号。若经过太仓市犬只管理平台小程序判断，认为您使用的账号是恶意注册、获取的号码，太仓市犬只管理平台小程序有权对相应账号采取限制、中止或终止使用等措施。</div>
                        <div class="agreement-detail">5.2您在使用本服务时，须通过太仓市犬只管理平台小程序提供的技术接口、登录页面及其他合法通道等进行平台或第三方账号和密码输入、个人信息授权等操作；否则，可能会造成的账号、密码泄漏或其他损失等由您自行承担。</div>
                        <div class="agreement-detail">5.3第三方负责其提供的具体网站、应用或其他服务的合法性、安全性以及真实性，若因任何第三方原因，造成您损失的，由第三方承担全部责任。</div>
                        <div class="agreement-detail">5.4您通过本服务使用平台或第三方账号登录、使用的网站、应用或服务等，应遵循您与第三方之间的协议、约定或第三方相关的规则等。</div>
                        <div class="agreement-detail">5.5您在使用平台提供的服务过程中，必须遵循法律法规、规章、规范性文件及政策要求的规定，遵守所有与平台、网络服务有关的网络协议、规定和程序，并不得利用太仓市犬只管理平台小程序从事以下行为：</div>
                        <div class="agreement-detail">(1）发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容；</div>
                        <div class="agreement-detail">(2）发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</div>
                        <div class="agreement-detail">(3）虚构事实、隐瞒真相以误导、欺骗他人；</div>
                        <div class="agreement-detail">(4）发表、传送、传播广告信息及垃圾信息；</div>
                        <div class="agreement-detail">(5）利用平台传输、发布违反国家法律法规政策的任何内容（信息）、涉及国家秘密和／或安全的信息、防碍互联网运行安全的信息；侵害他人合法权益的信息和／或其他有损于社会秩序、社会治安、公共道德的信息或内容、任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料等，且不得为他人实施上述行为提供任何便利；</div>
                        <div class="agreement-detail">(6）以任何技术手段或其他方式干扰太仓市犬只管理平台小程序及各项政务服务网上服务系统正常运行的，或干扰其他用户对太仓市犬只管理平台小程序服务使用的；</div>
                        <div class="agreement-detail">(7）通过任何方式搜集太仓市犬只管理平台小程序服务中其他用户的用户名、电子邮件等相关信息，并以发送垃圾邮件、连锁邮件、垃圾短信、即时消息等方式干扰、骚扰其他用户；</div>
                        <div class="agreement-detail">(8）从事其他违反法律法规、政策及公序良俗、社会公德等的行为或对互联网的正常运转造成不利影响的行为。</div>
                        <div class="agreement-detail">5.6太仓市犬只管理平台小程序服务仅供您个人使用，除非经太仓市犬只管理平台小程序书面许可，您不得进行以下行为：</div>
                        <div class="agreement-detail">(1）通过太仓市犬只管理平台小程序发布包含广告、宣传、促销等内容的信息；</div>
                        <div class="agreement-detail">(2）将太仓市犬只管理平台小程序提供的服务再次许可他人使用；</div>
                        <div class="agreement-detail">(3）其他超出太仓市犬只管理平台小程序正常服务功能之外的行为</div>
                        <div class="agreement-detail">5.7您充分了解并同意，您必须为自己注册账号下的一切行为负责，包括您所发表的任何内容、您进行的各项操作、您进行的授权以及由此产生的任何后果。</div>
                        <div class="agreement-detail">5.8如果太仓市犬只管理平台小程序发现或收到他人举报您发布的信息违反前述约定或本协议其他约定的，太仓市犬只管理平台小程序有权进行独立判断并采取技术手段予以删除、屏蔽或断开相关的信息链接。同时，太仓市犬只管理平台小程序有权视您的行为性质，采取包括但不限于暂停或终止本服务、追究法律责任等措施。太仓市犬只管理平台小程序有权判断用户的行为是否符合平台服务条款规定的权利，如果太仓市犬只管理平台小程序认为用户违背了本协议、法律法规政策等规定，太仓市犬只管理平台小程序有权随时变更、中断或终止部分或全部服务的权利，且无需事先告知。</div>
                        <div class="agreement-detail__subtitle">六、知识产权声明</div>
                        <div class="agreement-detail">6.1太仓市犬只管理平台小程序在服务中提供的任何软件、网站、商业标识、版面设计、排版方式、文字、图片、图形、音频、视频、有关数据等内容、功能和服务的著作权、商标权、专利权、商业秘密等知识产权均受中华人民共和国法律法规和相应的国际条约保护，太仓市犬只管理平台小程序所有者或技术支持方享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。</div>
                        <div class="agreement-detail">6.2您在使用太仓市犬只管理平台小程序的过程中，可能会使用到由第三方开发的在太仓市犬只管理平台小程序运行的功能、软件或服务，用户除遵守本协议相关规定以外，还应遵守第三方相关规定，并尊重第三方权利人对其功能、软件、服务及其所包含内容的相关权利。</div>
                        <div class="agreement-detail">6.3未经太仓市犬只管理平台小程序或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。</div>
                        <div class="agreement-detail__subtitle">七、第三方提供的服务</div>
                        <div class="agreement-detail">7.1本服务可能会使用第三方软件或技术，这种使用已经获得合法授权，您对本协议的签署及继续使用行为视为对接受第三方软件或技术服务的认可。</div>
                        <div class="agreement-detail">7.2如因太仓市犬只管理平台小程序使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，您使用太仓市犬只管理平台小程序上提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的服务或用户协议。太仓市犬只管理平台小程序和第三方之间对出现的纠纷在法律规定和约定的范围内各自承担责任。</div>
                        <div class="agreement-detail__subtitle">八、风险及免责</div>
                        <div class="agreement-detail">8.1您理解并同意：为了向您提供有效的服务，本服务会利用您终端设备的处理器和带宽等资源。在使用太仓市犬只管理平台小程序过程中可能产生数据流量的费用，您需自行向运营商了解相关资费信息，并自行承担相关费用。</div>
                        <div class="agreement-detail">8.2您在使用太仓市犬只管理平台小程序提供的服务时，须自行承担如下太仓市犬只管理平台小程序不可掌控的风险内容，包括但不限于：</div>
                        <div class="agreement-detail">(1）太仓市犬只管理平台小程序系统停机维护期间；</div>
                        <div class="agreement-detail">(2）电信设备出现故障不能进行数据传输的；</div>
                        <div class="agreement-detail">(3）由于网络供应商技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或延迟；</div>
                        <div class="agreement-detail">(4）用户的电脑软件、系统、硬件和通信线路出现故障；</div>
                        <div class="agreement-detail">(5）用户操作不当或通非太仓市犬只管理平台小程序授权的方式使用本服务；</div>
                        <div class="agreement-detail">(6）因受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏、台风、地震、海啸、洪水、停电战争、恐怖袭击等不可抗力之因素造成系统障碍不能执行业务的。</div>
                        <div class="agreement-detail">(7）其他太仓市犬只管理平台小程序无法控制或合理预见的情形。</div>
                        <div class="agreement-detail">8.3因您的过错导致的任何损失由您自行承担，该过错包括但不限于：不按照提示操作，未及时进行操作，遗忘或泄漏密码、校验码等，密码被他人破解，您使用的计算机或其他硬件、终端等被他人侵入或丢失，或您使用的软件被他人侵入，或者您的个人生物识别信息被他人利用。</div>
                        <div class="agreement-detail">8.4您理解并同意，因业务发展需要，太仓市犬只管理平台小程序有权在提前告知的前提下，对太仓市犬只管理平台小程序的全部或部分服务内容进行变更、暂停、限制、终止或撤销，用户需承担此风险。</div>
                        <div class="agreement-detail">8.5太仓市犬只管理平台小程序会根据您选择的服务类型向您提供相应的服务。您理解并同意，太仓市犬只管理平台小程序有权选择提供服务或开展合作的对象，有权决定功能开放、数据接口和相关数据披露的对象和范围，并有权视具体情况中止或终止向存有包括但不限于以下情形的用户提供本服务：</div>
                        <div class="agreement-detail">(1）违反法律法规或本协议规定的；</div>
                        <div class="agreement-detail">(2）影响使用者体验的；</div>
                        <div class="agreement-detail">(3）存在安全隐患的；</div>
                        <div class="agreement-detail">(4）违背本服务运营原则，或不符合太仓市犬只管理平台小程序其他管理要求的。</div>
                        <div class="agreement-detail__subtitle">九、法律责任</div>
                        <div class="agreement-detail">9.1您理解并同意，太仓市犬只管理平台小程序有权依合理判断对违反有关法律法规或本协议规定的行为追究责任，对违法违规的任何人士采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。</div>
                        <div class="agreement-detail">9.2您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；太仓市犬只管理平台小程序因此遭受损失的，您也应当一并赔偿。</div>
                        <div class="agreement-detail">9.3您理解并同意，您可向太仓市犬只管理平台小程序进行的任何索赔均限于已经发生的直接损失。</div>
                        <div class="agreement-detail__subtitle">十、协议的更新、变更</div>
                        <div class="agreement-detail">10.1协议的更新</div>
                        <div class="agreement-detail">本协议内容同时包括太仓市犬只管理平台小程序可能不定期发布的关于本服务的相关协议、服务声明、业务规则及公告指引等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，请同样遵守。否则，请立即停止使用本服务。</div>
                        <div class="agreement-detail">10.2协议的变更</div>
                        <div class="agreement-detail">您使用本服务即视为您已阅读并同意受本协议的约束。太仓市犬只管理平台小程序有权在必要时修改本协议条款。您在享受各项服务时，可以在相关页面中查阅最新的协议条款。本协议条款变更后，如果您继续使用本服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本服务，注销平台账号、停止使用本服务。</div>
                        <div class="agreement-detail">10.3协议的签署形式</div>
                        <div class="agreement-detail">如您对本协议条款内容有任何疑问，可向平台客服咨询。一旦点击"同意"或"接受"或"注册"按钮并成功注册，则与太仓市犬只管理平台小程序之间形成协议关系，应当受本协议条款的约束。</div>
                        <div class="agreement-detail__subtitle">十一、法律适用及管辖</div>
                        <div class="agreement-detail">11.1本协议的签订地为苏州市。</div>
                        <div class="agreement-detail">11.2本协议的订立、变更、执行和解释，以及与本协议有关的争议解决，均应适用中华人民共和国法律。如与本协议有关的某一特定事项没有法律规定或规定不明确，则应参照通用的国际商业惯例和行业惯例。</div>
                        <div class="agreement-detail">11.3如因本协议或本服务所引起或与其有关的任何争议应向苏州仲裁委员会提起仲裁。</div>
                        <div class="agreement-detail__subtitle">十二、通知与送达</div>
                        <div class="agreement-detail">12.1所有发给您的通知都可通过您在平台预留的通讯方式，以电子邮件、常规的信件或在网站显著位置公告的等方式进行传送。平台将通过上述方法之一将消息传递给您，告知您服务条款的修改、服务变更、或其它重要事情。</div>
                        <div class="agreement-detail">12.2您应当保证和维持资料的有效性，您的资料若存在虚假、无效等任何可能导致您无法及时获取业务通知、客户服务、投诉处理、纠纷协调、技术支持等情况的，由您自行承担相应责任。</div>
                        <div class="agreement-detail">12.3太仓市犬只管理平台小程序可以不定期以网页公告、电子邮件、手机短信、站内信、即时通讯工具等方式中的一种或多种向您发送与本服务有关的业务通知、服务提示、验证消息等各种业务通知。</div>
                        <div class="agreement-detail">12.4各方均应保证其联系方式真实、有效，通知自发送之日视为已送达收件人。</div>
                        <div class="agreement-detail__subtitle">十三、其他</div>
                        <div class="agreement-detail">13.1本协议自您同意勾选并成功注册为太仓市犬只管理平台小程序用户之日起生效，除非太仓市犬只管理平台小程序终止本协议或者您丧失太仓市犬只管理平台小程序用户资格，否则本协议始终有效。本协议终止并不免除用户根据本协议或其他有关协议、规则所应承担的义务和责任。</div>
                        <div class="agreement-detail">13.2本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</div>
                    </div>
                </div>
            </div>
        </transition>
        <div id="NELiveDetection" v-show="detection"></div>
        <div class="loadingBg" v-show="loading">
            <div class="loadingOne">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="loadingTip">请求中...</div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            loading:false,
            agreementSelect:false,
            agreement:false,
            userData:JSON.parse(sessionStorage.getItem("TC_PET_USERDATA")),
            petInfoUuid:"",
            form:{
                plateNo:{
                    key:"plateNo",
                    title:'宠物编号',
                    value:"",
                    hidden:true,
                    readonly:true
                },
                // petInfoUuid:{
                //     key:"petInfoUuid",
                //     title:'选择宠物',
                //     type:"select",
                //     selectList:[],
                //     value:"",
                //     readonly:true
                // },
                // petServiceUuid:{
                //     key:"petServiceUuid",
                //     title:'选择机构',
                //     type:"select",
                //     selectList:[],
                //     value:"",
                //     require:true
                // },
                // certificateNo:{
                //     key:"certificateNo",
                //     title:'狗证编号',
                //     value:""
                // },
                petName:{
                    key:"petName",
                    title:'宠物名称',
                    value:"",
                    require:false
                },
                // vaccines:{
                //     key:"vaccines",
                //     title:'疫苗信息',
                //     value:"",
                //     // require:true
                // },
                vaccinesStatus:{
                    key:"vaccinesStatus",
                    title:'疫苗是否注射',
                    value:"",
                    type:"select",
                    selectList:[
                        {uuid:0,name:"否"},
                        {uuid:1,name:"是"}
                    ],
                    // require:true
                },
                vaccinationTime:{
                    key:"vaccinationTime",
                    title:'疫苗注射时间',
                    value:"",
                    type:"date",
                    require:false
                },
                // vaccinesEffectiveTime:{
                //     key:"vaccinesEffectiveTime",
                //     title:'疫苗有效时间',
                //     value:"",
                //     type:"date",
                //     // require:true
                // },
                isCn:{
                    key:"isCn",
                    title:'证件类型',
                    value:1,
                    type:"radio",
                    selectList:[
                        {uuid:1,name:"身份证"},
                        {uuid:2,name:"护照"}
                    ],
                    // require:true
                },
                userName:{
                    key:"userName",
                    title:'主人姓名',
                    value:"",
                    require:true
                },
                userIdCard:{
                    key:"userIdCard",
                    title:'主人身份证号',
                    value:"",
                    require:true
                },
                userPhone:{
                    key:"userPhone",
                    title:'手机号码',
                    value:"",
                    require:true
                },
                userAddrss:{
                    key:"userAddrss",
                    title:'居住地址',
                    value:"",
                    require:true
                },
                petUrl:{
                    key:"petUrl",
                    title:'宠物照片',
                    value:"",
                    // url:"",
                    type:"image",
                    require:true
                },
                rentalContractUrl:{
                    key:"rentalContractUrl",
                    title:'房产证(租房合同)',
                    value:"",
                    // url:"",
                    type:"image",
                    require:false
                }
            },
            petList:{},
            imageUrl:process.env.VUE_APP_BASE_API,
            detection:false,
            errorType:{
                10000:"校验不通过",
                10001:"校验接口网络错误",
                11000:"获取相机权限失败",
                11001:"鉴权不通过",
                11002:"浏览器不支持",
                11003:"用户拒绝相机权限授权",
                11004:"找不到摄像头",
                11005:"异常硬件导致无法读取摄像头",
                11006:"摄像头分辨率过低",
                11007:"未知问题导致摄像头无法被使用",
                11008:"炫瞳检测失败",
                12000:"获取配置接口网络错误",
                12001:"获取配置失败，请检查接入配置是否正确",
            }
        }
    },
    mounted(){
        let params = this.getQueryParams()
        if(params.plateNo){
            this.form.plateNo.value = params.plateNo
        }
        // if(this.$route.query.plateNo){
        //     this.form.plateNo.value = this.$route.query.plateNo
        // }
        if(this.userData){
            this.form.userName.value = this.userData.name
            this.form.userIdCard.value = this.userData.userId
            this.form.userPhone.value = this.userData.phone
            this.form.userAddrss.value = this.userData.address
        }
        // this.$post("/pet/web/selectListByOpenId").then(res=>{
        //     if(res.status == 200){
        //         if(res.data.code == 200){
        //             let list = res.data.data || []
        //             let pet = {}
        //             list.forEach(item=>{
        //                 item.name = item.petName
        //                 pet[item.uuid] = item
        //             })
        //             this.form.petInfoUuid.selectList = list
        //             this.petList = pet
        //         }
        //     }
        // })
        // this.$fetch("/pet/web/selectOrgList").then(res=>{
        //     if(res.status == 200){
        //         if(res.data.code == 200){
        //             let list = res.data.data || []
        //             list.forEach(item=>{
        //                 item.name = item.orgName
        //             })
        //             this.form.petServiceUuid.selectList = list
        //         }
        //     }
        // })
    },
    methods:{
        getQueryParams() {
            var search = window.location.search;
            var queryParams = {};
            if (search) {
                search = search.substring(1); // 去掉问号
                var params = search.split('&');
                for (var i = 0; i < params.length; i++) {
                var pair = params[i].split('=');
                var paramName = decodeURIComponent(pair[0]);
                var paramValue = decodeURIComponent(pair[1]);
                queryParams[paramName] = paramValue;
                }
            }
            return queryParams;
        },
        readAgrement(){
            this.agreement = true
            this.agreementSelect = true
        },
        radioChange(value,key){
            if(key == "isCn"){
                this.form.isCn.value = value
                if(value == 1){
                    this.form.userIdCard.title = "主人身份证号"
                }else{
                    this.form.userIdCard.title = "主人护照编号"
                }
            }
        },
        selectChange(e,key){
            if(key == "petInfoUuid"){
                let pet = this.petList[e.target.value]
                if(pet){
                    this.form.petName.value = pet.petName
                    this.form.petUrl.value = pet.petUrl
                    this.form.rentalContractUrl.value = pet.rentalContractUrl
                    this.form.vaccines.value = pet.vaccines
                    this.form.vaccinationTime.value = pet.vaccinationTime
                    this.form.vaccinesEffectiveTime.value = pet.vaccinesEffectiveTime
                    this.form.certificateNo.value = pet.certificateNo
                    this.form.vaccinesStatus.value = pet.vaccinesStatus
                }else{
                    this.form.petName.value = ""
                    this.form.petUrl.value = ""
                    this.form.rentalContractUrl.value = ""
                    this.form.vaccines.value = ""
                    this.form.vaccinationTime.value = ""
                    this.form.vaccinesEffectiveTime.value = ""
                    this.form.certificateNo.value = ""
                    this.form.vaccinesStatus.value = ""
                }
            }else if(key == "vaccinesStatus"){
                if(e.target.value == 1){
                    this.form.vaccinationTime.require = true
                }else{
                    this.form.vaccinationTime.require = false
                }
            }else if(key == "isCn"){
                if(e.target.value == 1){
                    this.form.userIdCard.title = "主人身份证号"
                }else{
                    this.form.userIdCard.title = "主人护照编号"
                }
            }
        },
        getImage(input,type){
            var file = input.target.files[0];
            if(file){
                let formData = new FormData()
                formData.append("file",file)
                this.$post("/pet/web/upload",formData,{
                    headers:{'Content-Type' : 'multipart/form-data'}
                }).then(res=>{
                    for(let k in this.form){
                        if(k == type){
                            this.form[k].value = res.data.fileName
                            // this.form[k].url = res.data.url
                        }
                    }
                })
            }
        },
        confirm(){
            if(this.agreementSelect){
                if(this.form.isCn.value == 1){
                    let flag = true
                    for(let k in this.form){
                        if(this.form[k].require){
                            if(!this.form[k].value){
                                this.$tip(this.form[k].title+"不能为空")
                                flag = false
                            }
                        }
                    }
                    if(flag){
                        this.liveDetection()
                        // this.addPet()
                    }
                }else{
                    if(this.petInfoUuid){
                        this.bindPet()
                    }else{
                        this.addPet()
                    }
                }
            }else{
                this.$tip("请先阅读用户协议")
            }
        },
        liveDetection(){
            let _this = this
            const neLiveDetection = new NELiveDetection({
                businessKey: 'a6e20b45af9f47d0bfa4963f7c6762f4',
                container: '#NELiveDetection',
                diameter: 220,
                onMount: (instance) => {},
                // 等价于 instance.on('ready', () => {})
                onReady: (instance) => {
                    _this.detection = true
                },
                });

                // 实例化后必须调用 mount 方法
                neLiveDetection && neLiveDetection.mount();

                // 调用 start 方法开始活体检测流程
                neLiveDetection.on('ready', () => {
                    neLiveDetection.start();
                });

                // 流程走完并检验完成
                neLiveDetection.on('verify', (token) => {
                    _this.detection = false
                    neLiveDetection.dispose()
                    // 在校验成功后拿到 token 去做服务端校验
                    let data = {
                        cardNo:_this.form.userIdCard.value,
                        name:_this.form.userName.value,
                        token:token
                    }
                    _this.$post("/pet/web/wy/liveperson/audit",data).then(res=>{
                        if(res.data.data.status == 1){
                            if(_this.petInfoUuid){
                                _this.bindPet()
                            }else{
                                _this.addPet()
                            }
                        }else{
                            _this.$tip("人脸识别不通过")
                        }
                    })
                });
                neLiveDetection.on('timeout', () => {
                    _this.detection = false
                    neLiveDetection.dispose()
                    _this.$tip("人脸识别超时")
                });
                // 发生错误
                neLiveDetection.on('error', (err) => {
                    _this.$tip(_this.errorType[err.name])
                        // console.log(_this.detection);
                    setTimeout(() => {
                        _this.detection = false
                    }, 500);
                });
        },
        bindPet(){
            // if(!this.form.petServiceUuid.value){
            //     this.$tip("服务机构不能为空")
            // }
            let data = {
                petInfoUuid:this.petInfoUuid,
                plateNo:this.form.plateNo.value,
                // petServiceUuid:this.form.petServiceUuid.value,
            }
            let user = JSON.parse(sessionStorage.getItem("TC_PET_USERDATA"))
            data.openId = user.openId
            this.loading = true
            this.$post("/pet/web/binding",data).then(res=>{
                if(res.status == 200){
                    if(res.data.code == 200){
                        this.$tip("绑定成功")
                        setTimeout(() => {
                            this.$router.push({path:"/petList"})
                        }, 2000);
                    }else{
                        this.$tip(res.data.msg)
                    }
                }
                this.loading = false
            })
        },
        addPet(){
            let flag = true
            let data = {}
            for(let k in this.form){
                if(this.form[k].require){
                    if(!this.form[k].value){
                        this.$tip(this.form[k].title+"不能为空")
                        flag = false
                    }
                }
                data[k] = this.form[k].value
            }
            if(flag){
                data.isCertificate = 0
                delete data.petInfoUuid
                delete data.plateNo
                let user = JSON.parse(sessionStorage.getItem("TC_PET_USERDATA"))
                data.openId = user.openId
                // delete data.petServiceUuid
                this.loading = true
                this.$post("/pet/web/save",data).then(res=>{
                    if(res.status == 200){
                        if(res.data.code == 200){
                            this.petInfoUuid = res.data.data.uuid
                            this.bindPet()
                        }else{
                            this.$tip(res.data.msg)
                            this.loading = false
                        }
                    }else{
                        this.loading = false
                    }
                })
            }
        },
        back(){
            this.$router.push({path:"/petList"})
        }
    }
}
</script>
<style scoped lang="less">
    #NELiveDetection{
        width:100%;
        height: 100%;
        position: fixed;
        top:0;
        left:0;
        background-color: #fff;
    }
    .phone-box{
        width:100%;
        height: 100vh;
        overflow: auto;
        background-color: #f3f3f3;
        .message{
            .message-item{
                display: flex;
                flex-direction: row;
                padding:8px 15px;
                margin-bottom:1px;
                background-color: #fff;
            }
            .message-title{
                flex:0 0 110px;
                position: relative;
                color:#777;
                font-size: 14px;
                text-align: right;
            }
            .message-title__reuqire::after{
                content:"*";
                position: absolute;
                right:-8px;
                top:0;
                font-size: 12px;
                color:red;
            }
            .message-input{
                width:100%;
                flex:1;
                margin-left:10px;
                border:0;
                color:#333;
                font-size: 14px;
                background: #fff;
                outline: none;
            }
            .message-input__radio{
                display: flex;
                flex-direction: row;
                align-items: center;
            }
            .message-input__item{
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-right:15px;
                .message-input__image{
                    width:18px;
                    margin-right: 5px;
                }
                .message-input__label{
                    font-size: 14px;
                }
            }
            .message-image{
                width:100%;
            }
            .upload-input-box{
                width:80px;
                height: 80px;
                position: relative;
                margin-left:10px;
                overflow: hidden;
            }
            .upload-input{
                width:100%;
                height: 100%;
                position: absolute;
                top:0;
                left:0;
                opacity: 0;
            }
            .upload-btn{
                width:100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border:1px solid #f3f3f3;
                background-color: #fff;
                box-sizing: border-box;
                .upload-btn__image{
                    width:30px;
                    margin-bottom:10px;
                }
                .upload-btn__text{
                    font-size: 12px;
                    color:#999;
                    text-align: center;
                }
            }
        }
        .btn-box{
            display: flex;
            flex-direction: row;
            gap:10px;
            padding:0 20px;
            margin:20px 0;
            .btn{
                flex:1;
                padding:8px 25px;
                color:#317aed;
                font-size: 14px;
                border:1px solid #317aed;
                background-color: #fff;
                text-align: center;
                border-radius: 3px;
            }
            .btn-inner{
                background: #317aed;
                color:#fff;
            }
        }
    }
    .agreement{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding:8px 15px;
        background-color: #fff;
        font-size: 13px;
        color:#777;
        .agreement-select{
            width:15px;
            height: 15px;
            margin-right:10px;
            background: url("~@/assets/select.png") no-repeat 100% 100%;
            background-size: 100% 100%;
        }
        .agreement-selected{
            background: url("~@/assets/selected.png") no-repeat 100% 100%;
            background-size: 100% 100%;
        }
        .agreement-text{
            margin: 0 3px;
            color:#333;
            text-decoration: underline;
        }
    }
    .agreement-box{
        width:100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top:0;
        left:0;
        z-index: 10;
        background-color: rgba(0,0,0,0.7);
        .agreement-page{
            width:70%;
            height: 80%;
            display: flex;
            flex-direction: column;
            position: relative;
            overflow: height;
            padding:10px;
            background-color: #fff;
            border-radius: 5px;
        }
        .agreement-title{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom:10px;
            font-size: 17px;
            color:#333;
        }
        .close-image{
            width:20px;
            height: 20px;
        }
        .agreement-content{
            flex:1;
            overflow: auto;
        }
        .agreement-detail__title{
            font-size: 17px;
            color:#000;
            text-align: center;
            margin-bottom:10px;
        }
        .agreement-detail__introduction{
            font-size: 14px;
            color:#777;
            text-align: center;
            margin-bottom:10px;
        }
        .agreement-detail__subtitle{
            font-size: 15px;
            color:#000;
            margin-bottom:5px;
        }
        .agreement-detail{
            font-size: 14px;
            color:#333;
            margin-bottom:5px;
        }
    }
    .detailEnter-enter-active,
    .detailEnter-leave-active{
        transition:all 0.5s;
    }
    .detailEnter-enter{
        transform: scale(0);
        opacity: 0;
    }
    .detailEnter-enter-to{
        transform: scale(1);
        opacity: 1;
    }
    .detailEnter-leave{
        transform: scale(1);
        opacity: 1;
    }
    .detailEnter-leave-to{
        transform: scale(0);
        opacity: 0;
    }
    .gray{
        color:#777 !important;
    }
    .loadingBg{
        width:100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: fixed;
        top:0;
        left:0;
        background-color: rgba(0,0,0,0.3);
    }
    .loadingOne{
        width: 80px;
        height: 40px;
        position: relative;
        top:-10%;
        // margin: 0 auto;
    }
    .loadingOne span{
        display: inline-block;
        width: 8px;
        height: 100%;
        margin:0 3px;
        border-radius: 4px;
        background: lightgreen;
        -webkit-animation: load 1s ease infinite;
        animation: load 1s ease infinite;
    }
    .loadingTip{
        position: relative;
        top:-5%;
        font-size: 14px;
        color:#000;
    }
    @keyframes load{
        0%,100%{
            height: 40px;
            background: lightgreen;
        }
        50%{
            height: 70px;
            margin: -15px 3px;
            background: lightblue;
        }
    }
    @-webkit-keyframes load{
        0%,100%{
            height: 40px;
            background: lightgreen;
        }
        50%{
            height: 70px;
            margin: -15px 3px;
            background: lightblue;
        }
    }
    .loadingOne span:nth-child(2){
        -webkit-animation-delay:0.2s;
        animation-delay:0.2s;
    }
    .loadingOne span:nth-child(3){
        -webkit-animation-delay:0.4s;
        animation-delay:0.4s;
    }
    .loadingOne span:nth-child(4){
        -webkit-animation-delay:0.6s;
        animation-delay:0.6s;
    }
    .loadingOne span:nth-child(5){
        -webkit-animation-delay:0.8s;
        animation-delay:0.8s;
    }
</style>